import { useMemo } from "react"
import { paymentMethodIcon, paymentMethodLabel } from "src/checkout/components/stages/paymentForm/constants"
import { useCartState } from "src/checkout/hooks/useCart"
import { recordError } from "src/utilities/errorReporting"

const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"

export function isApplePaySupported() {
  return !!window.ApplePaySession?.canMakePayments() || !isProd
}

export function useSupportedPaymentMethods() {
  const paymentMethods = useCartState().data?.payment_methods

  return useMemo(() => {
    return (paymentMethods || []).filter((method) => {
      const icon = paymentMethodIcon[method]
      const label = paymentMethodLabel[method]

      if (!icon || !label) {
        recordError(`Payment method icon not found for ${method}`)
        return false
      }

      if (method === "mollie_wc_gateway_applepay") {
        return isApplePaySupported()
      }

      return true
    })
  }, [paymentMethods])
}

export function useSupportedMolliePaymentMethods() {
  const supportedPaymentMethods = useSupportedPaymentMethods()

  return useMemo(() => {
    return supportedPaymentMethods.filter((method) => method.startsWith("mollie_wc_gateway_"))
  }, [supportedPaymentMethods])
}
